import { View } from 'react-native';
import styled from 'styled-components/native';
import webStyled from 'styled-components';

import { Text } from 'src/styles';

export const Container = styled(View)`
  margin-top: 20px;
  padding: 10px;
  border-width: 2px;
  border-color: black;
  border-style: solid;
  border-radius: 4px;
`;

export const TitleContainer = styled(View)`
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled(Text)`
  font-size: 24px;
  margin-bottom: 12px;
  font-weight: 600;
`;

export const Warning = styled(Text)`
  font-size: 20px;
  font-weight: 600;
  color: red;
`;

// Keeps the spinner and label centred inside the shared Button without
// changing that Button's layout for every other caller.
export const SubmittingLabel = webStyled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
